import React from "react";
import "./StaffAugmentation.css";
import TarjetaDeServicio from "../ia/components/TarjetaDeServicioIa";
import GestionIa from "../ia/components/GestionIa";
import { useTranslation } from "react-i18next";

interface StaffWhyItem {
  title: string;
  desc: string;
}

export default function StaffAugmentation() {
  const { t } = useTranslation();

  const whyChooseUs: StaffWhyItem[] = [
    { title: t("pages.staff.1.title"), desc: t("pages.staff.1.desc") },
    { title: t("pages.staff.2.title"), desc: t("pages.staff.2.desc") },
    { title: t("pages.staff.3.title"), desc: t("pages.staff.3.desc") },
    { title: t("pages.staff.4.title"), desc: t("pages.staff.4.desc") },
    { title: t("pages.staff.5.title"), desc: t("pages.staff.5.desc") },
  ];

  return (
    <>
      <section
        className="fondo-sa"
        style={
          {
            backgroundImage: 'url("/equipo3.webp")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            minHeight: "750px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          } as React.CSSProperties
        }
      >
        <div className="sa-overlay">
          <h1 className="sa-titulo">{t("pages.staff.hero_title")}</h1>
          <p className="sa-descripcion">{t("pages.staff.hero_desc")}</p>
        </div>
      </section>

      {/* Título principal con margen inferior reducido */}
      <h2 className="sa-subtitulo" style={{ marginBottom: "1rem" }}>
        {t("pages.staff.why_title")}
      </h2>

      {/* Nuevo subtítulo reciclando la clase de descripción y centrándolo */}
      <p
        className="sa-descripcion"
        style={{
          textAlign: "center",
          margin: "0 auto 4rem auto",
        }}
      >
        {t("pages.staff.why_subtittle")}
      </p>

      <div className="sa-card-grid">
        {whyChooseUs.map((service, index) => (
          <TarjetaDeServicio
            key={index}
            service={service}
            animationClass="from-bottom"
            delay={index * 0.2}
          />
        ))}
      </div>

      <GestionIa
        titulo={null}
        subtitulo={t("pages.staff.gestion_subtitle")}
        introText={t("pages.staff.gestion_intro")}
        gestion={[]}
        alcance={[
          { titulo: t("pages.staff.alcance.0.titulo") },
          { titulo: t("pages.staff.alcance.1.titulo") },
          { titulo: t("pages.staff.alcance.2.titulo") },
          { titulo: t("pages.staff.alcance.3.titulo") },
        ]}
      />
    </>
  );
}
